import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'

export default function Logout() {
  const { signOut } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    signOut().finally(() => {
      navigate('/auth/login', { replace: true })
    })
  }, [signOut, navigate])

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'var(--olv-text-tertiary)',
        fontFamily: 'var(--font-mono)',
        fontSize: 11,
        letterSpacing: '0.10em',
      }}
    >
      SIGNING OUT…
    </div>
  )
}
